import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { LoginPage } from "./auth/LoginPage";
import { DashboardPage } from "./dashboard/DashboardPage";
import { LandingPage } from "./public/LandingPage";
import { AdminPage } from "./admin/AdminPage";
import { TermsPage } from "./public/TermsPage";
import { ApiDocsPage } from "./public/ApiDocsPage";

declare global {
  interface Window {
    whop?: { track: (event: string, ...args: unknown[]) => void };
  }
}

// The Whop pixel in index.html fires once on the initial HTML load, but this is
// a client-routed SPA — subsequent route changes never reload the page. Fire a
// view_content event on every page view, including the first render.
function usePageViewTracking() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.whop?.track("view_content");
  }, [pathname]);
}

export function App() {
  usePageViewTracking();
  return <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/app/*" element={<DashboardPage />} />
    <Route path="/admin" element={<AdminPage />} />
    <Route path="/terms" element={<TermsPage />} />
    <Route path="/api-docs" element={<ApiDocsPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>;
}
